(() => {
  const initAnnouncementBar = (root) => {
    if (!root || root.dataset.elonailAnnouncementReady === 'true') return;
    root.dataset.elonailAnnouncementReady = 'true';

    const viewport = root.querySelector('[data-elonail-announcement-viewport]');
    const items = [...root.querySelectorAll('[data-elonail-announcement-item]')];
    const autoplay = root.dataset.autoplay === 'true';
    const speed = Math.max(2000, Number(root.dataset.speed || 5) * 1000);

    if (!viewport || items.length < 2) return;

    let timer = null;
    let paused = false;

    const hasOverflow = () => viewport.scrollWidth > viewport.clientWidth + 2;

    const getClosestIndex = () => {
      const left = viewport.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const goNext = () => {
      if (!hasOverflow()) return;
      const currentIndex = getClosestIndex();
      const nextIndex = currentIndex >= items.length - 1 ? 0 : currentIndex + 1;
      viewport.scrollTo({ left: items[nextIndex].offsetLeft, behavior: 'smooth' });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!autoplay || paused || document.hidden || !hasOverflow()) return;
      timer = window.setInterval(goNext, speed);
    };

    root.addEventListener('mouseenter', () => {
      paused = true;
      stop();
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
      start();
    });
    root.addEventListener('focusin', () => {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', () => {
      paused = false;
      start();
    });

    document.addEventListener('visibilitychange', start);
    window.addEventListener('resize', start, { passive: true });

    start();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-elonail-announcement-bar]').forEach(initAnnouncementBar);
  };

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
